import PropTypes from "prop-types";
import React, { forwardRef } from "react";

import useInputFocus from "../../hooks/useInputFocus";
import { FieldContainer, InputContainer, InputField, InputLabel } from "./InputComponents";

const Input = forwardRef((props, ref) => {
  const { disabled, id, isError, isValid, label, ...rest } = props;
  const [focused, onInputBlur, onInputFocus] = useInputFocus();
  return (
    <InputContainer>
      {label && (
        <InputLabel htmlFor={id} isValid={isValid} disabled={disabled}>
          {label}
        </InputLabel>
      )}
      <FieldContainer isError={isError} focused={focused} onFocus={onInputFocus} onBlur={onInputBlur}>
        <InputField disabled={disabled} id={id} isValid={isValid} isError={isError} ref={ref} {...rest} />
      </FieldContainer>
    </InputContainer>
  );
});

Input.defaultProps = {
  disabled: false,
  label: null,
  isValid: true,
  isError: false,
};

Input.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  isValid: PropTypes.bool,
  isError: PropTypes.bool,
};

export default Input;
